import CellInput from './CellInput'

export default CellInput
